import React from 'react';
import { connect, useSelector } from 'react-redux';
import { Typography } from '@drone-js/core';
import { mapStateToProps, AboutActivityModularProps } from 'component/page/detail/MoreInfoSections/AboutActivity/AboutActivity.selectors';
import AgodaMarkdown from 'component/common/AgodaMarkdown/AgodaMarkdown';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesAboutActivityContainerSeenEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesAboutActivityContainerSeenEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import { selectFeatureExperimentsFromBootstrap } from 'store/slice/bootstrap';

const AboutActivityModular: React.FC<AboutActivityModularProps> = (props) => {
    const { content } = props;
    const shouldShowAboutActivity = useSelector(selectFeatureExperimentsFromBootstrap).featureBehavior.ShowAboutActivityPanel;

    React.useEffect(() => {
        if (shouldShowAboutActivity && content) {
            trackElementEvent<ActivitiesAboutActivityContainerSeenEventActivitiesFieldsV1>(ActivitiesAboutActivityContainerSeenEventActivitiesManifestV1.ids, {
                is_toggle_on: true,
            });
        }
    }, [content, shouldShowAboutActivity]);

    if (!content || !shouldShowAboutActivity) return null;

    return (
        <Typography variant="body-s" tag="p">
            <AgodaMarkdown input={content} />
        </Typography>
    );
};
AboutActivityModular.displayName = 'AboutActivityModular';

export default connect(mapStateToProps)(AboutActivityModular);
